import React, { Component } from "react";
import Navigation from "../Navbar/navbar.js";

class NavContainer extends Component {
  render() {
    return <Navigation />;
  }
}

export default NavContainer;
